import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { upcomingEvent } from "../../../data/collections";
import { useSiteAssets, optimized } from "../../../siteAssets";
import styles from "./styles.module.css";

const pad = (n) => String(n).padStart(2, "0");

const Countdown = ({ target }) => {
  const getLeft = () => Math.max(0, new Date(target).getTime() - Date.now());
  const [left, setLeft] = useState(getLeft);

  useEffect(() => {
    const id = setInterval(() => setLeft(getLeft()), 1000);
    return () => clearInterval(id);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [target]);

  if (left <= 0) return <p className={styles.dropped}>Now available</p>;

  const cells = [
    [Math.floor(left / 86400000), "Days"],
    [Math.floor((left % 86400000) / 3600000), "Hrs"],
    [Math.floor((left % 3600000) / 60000), "Min"],
    [Math.floor((left % 60000) / 1000), "Sec"],
  ];

  return (
    <div className={styles.countdown} aria-label="Time until drop">
      {cells.map(([value, label]) => (
        <div className={styles.count} key={label}>
          <span className={styles.countNum}>{pad(value)}</span>
          <span className={styles.countLbl}>{label}</span>
        </div>
      ))}
    </div>
  );
};

const PreorderTeaser = () => {
  const assets = useSiteAssets();
  if (!upcomingEvent) return null;

  return (
    <section className={styles.wrap} id="preorder">
      <div
        className={styles.band}
        style={{
          backgroundImage: `linear-gradient(105deg, rgba(15,13,11,0.82) 0%, rgba(15,13,11,0.45) 55%, rgba(15,13,11,0.2) 100%), url(${
            assets.event ? optimized(assets.event) : upcomingEvent.image
          })`,
        }}
      >
        <div className={styles.inner}>
          <span className={styles.eyebrow}>
            <span className={styles.dot} />
            {upcomingEvent.date
              ? `Upcoming Event · ${upcomingEvent.location}`
              : "The LORMAMI Community"}
          </span>
          <h2 className={styles.title}>{upcomingEvent.title}</h2>
          <p className={styles.tag}>{upcomingEvent.blurb}</p>
          {upcomingEvent.date && <Countdown target={upcomingEvent.date} />}
          <div className={styles.actions}>
            <Link to="/collections" className={styles.cta}>
              Register Now
            </Link>
            <Link to="/collections" className={styles.ctaGhost}>
              View Collections
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
};

export default PreorderTeaser;
